export default __webpack_public_path__ + "static/media/illustration-algohealth-w@3x.7d041aef.png";